


















































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import anime from "animejs";

@Component({})
export default class Logo1 extends Vue {
}
